export default {
  id: "32477ccc-9911-4b36-a07c-3eb6ef79807b",
  icon: "mdi-card-text",
  name: "flashCard",
  title: "Flash Card",
  description: "Customizable block for Flash Card library content.",
};
